import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
// import NProgress from 'nprogress'

Vue.use(VueRouter)

const routes = [
	 {
		path: "/login-weixin",
		name: "login-weixin",
		component: () => import("@/views/login-weixin"),
		meta: {
			title: "授权登录",
			anonymous: true,
		},
	}, {
		path: "/weixin-authorize",
		name: "weixin-authorize",
		component: () => import("@/views/login-weixin"),
		meta: {
			title: "授权登录",
			anonymous: true,
		},
	},{
		name: 'login',
		path: '/login',
		component: () => import('@/views/login'),
		children: [],
		meta: {
			anonymous: true
		}
	}, {
		name: 'loginSimple',
		path: '/simple-authorize',
		component: () => import('@/views/login-simple'),
		children: [],
		meta: {
			anonymous: true
		}
	}, {
		name: 'transit',
		path: '/transit',
		component: () => import('@/views/transit'),
		children: [],
		meta: {
			anonymous: true
		}
	},  {
		name: 'framework',
		path: '/',
		component: () => import('@/views/framework'),
		children: [{
			name: 'dashboard',
			path: '/dashboard',
			component: () => import('@/views/dashboard'),
		},{
			name: 'todo-list',
			path: '/todo-list',
			component: () => import('@/views/todo-list'),
			children: [],
			meta: {
				anonymous: true
			}
		}],
		meta: {
			anonymous: true
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})


const setAppRoute = async () => {
	const configStore = await store.dispatch('config/get');
	const appRoute = [];
	//let defaultRoute = {};
	let apps = configStore.config.apps;
	if(!apps){
		apps = configStore.config
	}
	for (var app in apps) {
		appRoute.push({
			name: apps[app].route.name,
			path: '/' + apps[app].route.name,
			component: () => import('@/views/framework'),
			children: [{
				path: apps[app].route.path,
				component: () => import('@/views/index'),
			}]
		})
	}
	router.addRoutes(appRoute)
}

setAppRoute();

router.afterEach(async (to, from, next) => {
	//未完成挂载
	if(!window.merchApp){
		  return;
	}
	//链接无需验证授权
	if (to.meta && to.meta.anonymous) {
		return
	}
	const raclStore = await store.dispatch('racl/get', true);
	//const identityStore = await store.dispatch('identity/get');
	//已过期30天，后台不能访问
	if (raclStore.identity.data.daysBeforeExpiration < -30) {
		router.push({
			path: '/core/401'
		})
		return
	}
	
	
	if(to.path.indexOf('/lce/editor') == 0){
		store.commit('sidebar/float')
	}
	await store.dispatch("helperDoc/get",to.path);
	//const menuStore = await store.dispatch('menu/get');
	//const featureStore = await store.dispatch('feature/get');

	//查找最匹配的地址
	let matchestMenu = null
	let matchestScore = 0;
	let sid = to.query.sid
	for(const ele of raclStore.menu.list){
		if(sid && ele.id == sid){
			matchestMenu = ele
			break;
		}
		else if (ele.url && to.fullPath.indexOf(ele.url) >= 0) {
			if(matchestScore < ele.url.length){
				matchestScore = ele.url.length
				matchestMenu = ele
			}
		}
	}
	
	if(raclStore.identity.data.racl == 1){
		
		let resource = await merchApp.$command
		.execute({
			api: "/racl-merch-api/racl/getResourceByUrl",
			parameter: {consoleUrl:to.fullPath},
		})
		//无权访问
		if (resource.data && resource.data.key && !raclStore.feature.keys.some(ele => ele == resource.data.key)) {
			alert('无权访问：'+ resource.data.name + ',请联系管理员')
			router.push({
				path: '/core/401'
			})
			return
		}

	}
	if (!matchestMenu) {
		return
	}
	store.commit('racl/updateCurrent', matchestMenu)
	//next()
})
export default router